import React from 'react';
import PromoIcon from 'images/icons/tag.svg?react-svg';
import { gridItemDiscount } from '../styles.mod.scss';
import { sansSerifRegular, fontSizeXS } from 'scy/text/styles.mod.scss';
import { packageQtyDiscount } from 'shared/models/product';
import margin from 'scy/margin.mod.scss';

export default function ProductDiscount({ product }) {
  if (!product.price) return null;

  const text = product.free_shipping
    ? 'Free Shipping'
    : product.package_qty
    ? packageQtyDiscount(product)
    : null;

  if (!text) return null;

  return (
    <div className={gridItemDiscount}>
      <PromoIcon width={11} height={11} />
      <span className={`${sansSerifRegular} ${fontSizeXS} ${margin.left_xxs}`}>
        {text}
      </span>
    </div>
  );
}
